import React from "react";
import { Link } from "@quintype/components";

import "./not-found.m.css";

const NotFoundPage = () => (
  <div styleName="container">
    <h1 styleName="error-code">404</h1>
    <h3 styleName="error-preview">Sorry, page not found</h3>
    <p styleName="error-message">Unfortunately the page you are looking for does not exist</p>
    <div styleName="homepage-link-wrapper">
      <Link href="/" styleName="homepage-link">
        Go back to Home Page
      </Link>
    </div>
  </div>
);

export { NotFoundPage };
